import { useEffect } from "react";
import { tEnglish as t } from "@buza/i18n";

// Shell only. Screens arrive with their stories; every phrase comes from a key (TRN-01).
export function App() {
  useEffect(() => {
    document.title = t("family.shell.app_name");
  }, []);
  return (
    <main>
      <h1>{t("family.shell.app_name")}</h1>
      <p>{t("family.shell.coming_soon")}</p>
    </main>
  );
}
